import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import TransactionsOverview from "@/components/TransactionsOverview.vue";
import UnresolvedPayments from "@/components/UnresolvedPayments.vue";
let Transactions = class Transactions extends Vue {
    listeners = [];
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    async mounted() {
        this.listeners.push(await this.$store.dispatch('transaction/listen'));
    }
    beforeDestroy() {
        for (let endListener of this.listeners) {
            endListener();
        }
    }
};
Transactions = __decorate([
    Component({
        components: {
            UnresolvedPayments,
            TransactionsOverview,
        },
    })
], Transactions);
export default Transactions;
